import { ILoginResponse } from '@aqx-core/common/api/auth';
import { IOMSLoginMobileParams, IOMSLoginParams } from '@aqx-core/common/api/oms-login';
import { request } from '@aqx-core/common/request';

interface IOMSLoginResponse extends ILoginResponse {}

export default {
  demoLogin: (params: IOMSLoginParams) => {
    return request.post<IOMSLoginResponse>('/api/auth/v2/company/demo/login', params);
  },
  demoLoginMobile: (params: IOMSLoginMobileParams) => {
    return request.post<IOMSLoginResponse>('/api/auth/v2/company/demo/mobile/login', params);
  },
  liveLogin: (params: IOMSLoginParams) => {
    return request.post<IOMSLoginResponse>('/api/auth/v2/company/live/login', params);
  },
  liveLoginMobile: (params: IOMSLoginMobileParams) => {
    return request.post<IOMSLoginResponse>('/api/auth/v2/company/live/mobile/login', params);
  }
};
